/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {
  FETCH_CURRENT_USER,
  FETCH_CURRENT_USER_ERROR,
  FETCH_CURRENT_USER_SUCCESS,
  CLEAR_CURRENT_USER,
  SET_CURRENT_COMPANY_ID,
} from './constants';

// The initial state of the App
export const initialState = {
  loading: false,
  error: false,
  currentUser: {},
  currentCompanyId: null,
};

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CURRENT_USER:
        draft.loading = true;
        draft.error = false;
        draft.currentUser = {};
        break;

      case FETCH_CURRENT_USER_SUCCESS:
        draft.currentUser = action.user;
        draft.loading = false;
        break;

      case FETCH_CURRENT_USER_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CLEAR_CURRENT_USER:
        draft.loading = false;
        draft.error = false;
        draft.currentUser = {};
        break;

      case SET_CURRENT_COMPANY_ID:
        draft.currentCompanyId = action.companyId;
        break;
    }
  });

export default appReducer;
